import { Administration } from "../../../listsSettings/administration";

export const allItems: string = `/${Administration.InternalName}/_lists/${Administration.Lists.Users.InternalName}/_pages/all_items`;
export const dispForm: string = `/${Administration.InternalName}/_lists/${Administration.Lists.Users.InternalName}/_pages/disp`;
